import React, {Component} from 'react';

import Search from "../core/Search";

class Villes extends Component {

    constructor(props) {
        super(props);

        this.externalCall = this.externalCall.bind(this);
    }

    externalCall(method) {
        if (method === "addVille") {
            this.props.history.push('/admin/ville/');
        }
    }

    render() {
        return (
            <Search
                initData={{DATAGRID_SCREEN_ID: 112}}
                externalCall={this.externalCall} />
        );
    }
}

export default Villes;